'use strict';
import { observable, action } from 'mobx';
import { fetch } from '@/lib/fetchAPI';
import globalStore from '../Global';

class DeviceInfoConnectStore {
  @observable
  topic = {
    type: 'ssh',
    subType: ''
  };
  @observable ip = '';
  @observable port = '';
  @observable formData = {};
  @observable duration = false;
  @observable timeLeft = false;

  sshStatus(deviceId) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在连接中...';
    return fetch(
      `/api/ssh/status?device_id=${deviceId}`,
      { method: 'GET' },
      json => json
    );
  }
  @action
  sshRequest(deviceId, publicKey, periodMinutes) {
    let data = {
      deviceId: deviceId,
      publicKey: publicKey,
      periodMinutes: periodMinutes
    };
    return fetch(
      `/api/ssh/request`,
      {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(data)
      },
      json => json
    );
  }
  @action
  sshClose(deviceId) {
    fetch(
      `/api/ssh/close?device_id=${deviceId}`,
      { method: 'POST' },
      json => {}
    );
  }
}
export default new DeviceInfoConnectStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceConnect.js